export const T = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  logoutBtn: "logout-btn",
  sidebarLink: (m) => `sidebar-link-${m}`,
  moduleTitle: (m) => `module-title-${m}`,
  searchInput: (m) => `search-input-${m}`,
  newBtn: (m) => `new-${m}-btn`,
  exportBtn: (m) => `export-${m}-btn`,
  importBtn: (m) => `import-${m}-btn`,
  saveBtn: "save-btn",
  deleteBtn: "delete-btn",
  cancelBtn: "cancel-btn",
  formInput: (name) => `input-${name}`,
  row: (m, id) => `row-${m}-${id}`,
  kpi: (name) => `kpi-${name}`,
  ordersTable: "orders-table",
  orderDetail: "order-detail",
  orderSection: (name) => `order-section-${name}`,
};
